<template>
  <div class="card p-3 mb-3 shadow">
    <div class="py-3 px-4 text-center text-uppercase font-weight-bold text-secondary bg-light border">
      {{title}}
    </div>

    <div
      v-for="item in data"
      :key="item.id"
      class="border-right border-left">
      <div class="py-3 px-4 border-bottom bg-light font-weight-bold text-secondary">
        {{item.name}}
      </div>

      <div
        v-for="prescription in item.prescriptions"
        :key="prescription.id"
        class="border-bottom">
        <div class="row">
          <div class="col-6 py-2">
            <div
                @click="choosePrescription(prescription.id)"
                class="pl-4 text-nowrap">
              {{prescription.drug.name}}
              {{prescription.drug.measure}}
              {{prescription.drug.measureUnit}}

              <small class="text-muted">
                {{prescription.drug.manufacturer.name}}
              </small>
            </div>

            <div class="pl-4 text-nowrap text-muted">
              <small>
                {{ prescription.quantity }}
                {{declineNumber(prescription.quantity, prescription.drug.format.name)}}
              </small>

              <small>
                {{ prescription.times.map(time => time.name).join(', ') }};
                {{ prescription.methods.map(method => method.name).join(', ') }}
              </small>
            </div>
          </div>

          <div class="col-6">
            <div class="row">
              <div class="col-4 py-2 border-left">
                <div>
                  {{prescription.duration}}
                  {{declineNumber(prescription.duration, 'день')}}
                </div>

                <div class="text-nowrap text-muted">
                  <small>
                    {{formatDate(prescription.startDate, 'd.m.y')}} -
                    {{formatDate(prescription.finishDate, 'd.m.y')}}
                  </small>
                </div>
              </div>

              <div class="col-3 border-left text-center">
                <div
                    v-if="prescription.startedAt"
                    class="text-nowrap py-2">
                  <div class="text-success">
                    <div>начат</div>

                    <div>
                      <small>{{formatDate(prescription.startedAt, 'd.m.y')}}</small>
                    </div>
                  </div>
                </div>

                <div
                    v-else
                    class="text-warning py-3">
                  не начат
                </div>
              </div>

              <div class="col-5 py-3 border-left">
                {{prescription.createdBy ? prescription.createdBy.lastname : ''}}
                {{prescription.createdBy ? prescription.createdBy.firstname : ''}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';
import declineNumber from '../../../utils/declensionNumbers';
import {FORMAT_NAMES, MS_IN_DAY} from '../../../constants';
import declensionNumbers from "../../../utils/declensionNumbers";

export default {
  name: 'ClientDrugList',

  props: ['title', 'prescriptions'],

  computed: {
    data() {
      const data = {};

      for(const prescription of this.prescriptions) {
        const key = prescription.drug.ingredient.catalog.id;

        if (typeof data[key] === 'undefined') {
          data[key] = {
            id: prescription.drug.ingredient.catalog.id,
            name: prescription.drug.ingredient.catalog.name,
            prescriptions: [],
          };
        }

        const finishDate = new Date(prescription.finishDate);
        const startDate = new Date(prescription.startDate);
        const diffInMs = finishDate.getTime() - startDate.getTime() + MS_IN_DAY;

        prescription.duration = parseInt(diffInMs / MS_IN_DAY);
        data[key].prescriptions.push(prescription);
      }

      return data;
    },
  },

  methods: {
    formatDate(date, format) {
      return formatDate(new Date(date), format);
    },

    declineNumber(count, name) {
      const formatName = FORMAT_NAMES.find(item => item[0] === name);
      const [, few, one, two ] = formatName || [name, name, name, name];

      return declineNumber(count, few, one, two);
    },

    choosePrescription(id) {
      this.$emit('choose', id);
    },
  },
};
</script>
